<template>
  <div id="info-counselor" class="container">
    <div class ="header-info-counselor">
      <div class="categories-element col-md-4 col-sm-12">
        <div class="categories">
          <div v-for="service in info_page.user_info.service_detail"
          class="services">
            <a href="#" class="btn badge badge-secondary">{{service.name}}</a>
          </div>          
        </div>
        <a v-if="info_page.user_info.linkedin != ''" :href="info_page.user_info.linkedin"><i class="fa fa-linkedin"></i></a>
      </div>
      <div class="avatar-counselor col-md-4 col-sm-12">
        <img class="avatar-image" :src="image_avatar">
        <h4 class="name-counselor">{{info_page.user_info.name}}</h4>
        <div class="counselor-title">{{info_page.user_info.counselor_title}}</div>
      </div>
      <div class="info-address col-md-4 col-sm-12">
        <div class="container-info-address">
          <div class="contain-address-time">
            <div class="address-counselor">
              <i class="fa fa-map-marker"></i> {{info_page.user_info.address}}
            </div>
            <div class="start-with-mora">
              <i class="fa fa-history"></i>Tham gia Mora từ 2019
            </div>
          </div>          
          <router-link
            v-if="info_page.status_page == 'counselor-information'" 
            :to="'/booking?id=' + info_page.user_info.id">
            <i class="far fa-calendar-alt"></i>
              <button class="booking btn">Đặt lịch hẹn <i class="fa fa-calendar-alt"></i></button>
          </router-link>
        </div>
      </div>
    </div>
    <div class="content-table col-md-12">
      <ul class="nav nav-pills nav-fill flex-column flex-sm-row">
        <li class="nav-item">
          <a class="" data-toggle="tab" href="#introduce-section">Giới thiệu về bản thân</a>
        </li>
        <li class="nav-item">
          <a class="" data-toggle="tab" href="#degree-section">Bằng cấp</a>
        </li>
        <li v-if="info_page.user_info.experience.length > 0" class="nav-item">
          <a class="" data-toggle="tab" href="#experience-section">Kinh nghiệm làm việc</a>
        </li>
        <li class="nav-item">
          <a class="" data-toggle="tab" href="#rating-and-review">Nhận xét và đánh giá</a>
        </li>
      </ul>
    </div>
    <div class="body-info-counselor">
      <div class="overview col-md-4">
        
        <div class="overview-info">
          <div class="title-overview">Tổng quan về Cố vấn</div>
          <div class="education-level contain-info">
            <i class="fa fa-graduation-cap icon-elelment"></i>
            <div class="">
              <span>Trình độ học vấn cao nhất</span>
              <div>{{info_page.user_info.level_education}}</div>
            </div>            
          </div>
        </div>
        <div class="service_info">
          <div class="title-overview">Dịch vụ cung cấp</div>
          <div>
            <div class="nav-wrapper">
              <div v-if="info_page.status_page == 'preview'">
                <ul class="nav nav-pills flex-md-row" id="tabs-icons-text" role="tablist">
                  <li v-for="(service, index) in info_page.user_info.available_service" class="nav-item">
                    <a class="nav-link mb-sm-3" 
                        @click="show_content(service.alias_name)" 
                        :class = "{active: service_show==service.alias_name}"
                        role="tab" aria-controls="tabs-icons-text-1">
                        <i :class="{'fa-comments': service.alias_name=='insider',
                        'fa-graduation-cap': service.alias_name=='tutor',
                        'fa-edit': service.alias_name=='essay-counselor',
                        'fa-star': service.alias_name=='strategist'
                        }" class="fa"></i></a>
                  </li>
                </ul>
              </div>
              <div v-else>
                <ul class="nav nav-pills flex-md-row" id="tabs-icons-text" role="tablist">
                  <li v-for="(service, index) in info_page.user_info.service_detail" class="nav-item">
                    <a class="nav-link mb-sm-3" 
                        @click="show_content(service.alias_name)" 
                        :class = "{active: service_show==service.alias_name}"
                        role="tab" aria-controls="tabs-icons-text-1">
                        <i :class="{'fa-comments': service.alias_name=='insider',
                        'fa-graduation-cap': service.alias_name=='tutor',
                        'fa-edit': service.alias_name=='essay-counselor',
                        'fa-star': service.alias_name=='strategist'
                        }" class="fa"></i></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card shadow">
              <div class="card-body">
                <div class="tab-content" id="myTabContent">
                  <div v-if="info_page.status_page == 'preview'" >
                    <div v-for="service in info_page.user_info.available_service"
                    class="tab-pane show fade"
                    :class="{active: service_show==service.alias_name}">
                      <div class="title-service">{{service.name}}</div>
                      <div class="">
                        <!-- <div class="title"> Mô tả</div> -->
                        <div class="">{{service.description || $t('DEFAULT.DESCRIPTION')}}</div>
                      </div>
                      <div class="price_service">
                        <span class="price-title">Giá</span>
                        <span class="price">{{service.price || $t('DEFAULT.PRICE')}}</span>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div v-for="service in info_page.user_info.service_detail"
                    class="tab-pane show fade"
                    :class="{active: service_show==service.alias_name}">
                      <div class="title-service">{{service.name}}</div>
                      <div class="">
                        <!-- <div class="title"> Mô tả</div> -->
                        <div class="">{{service.description || $t('DEFAULT.DESCRIPTION')}}</div>
                      </div>
                      <div class="price_service">
                        <span class="price-title">Giá</span>
                        <span class="price">{{service.price || $t('DEFAULT.PRICE')}}</span>
                      </div>
                    </div>
                  </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="information col-md-8">
        <div class="introduce-section" id="introduce-section">
          <h2 class="title">Giới thiệu về bản thân</h2>
          <p class="intro" v-html="introduce"></p>
        </div>
        <div class="degree-section" id="degree-section">
          <h2 class="title'">Bằng cấp</h2>
          <div class="degree-group">
            <div v-for="(de, index) in info_page.user_info.degree" :key="index" >
              <div class="graduating">           
                <i class="fa fa-graduation-cap"></i>
                <div class="info-graduating">
                  <div class="university-major">
                    <strong class="university-name">{{de.university}}</strong>
                    <span>{{de.major}}</span>
                  </div>
                  <div class="time-line">
                    <span>{{de.start_date}} - </span>
                    <span>{{de.end_date}}</span>
                  </div>
                </div>              
              </div>              
            </div>
          </div>           
        </div>
        <div v-if="info_page.user_info.experience.length > 0" class="experience-section" id="experience-section">
          <h2 class="title">Kinh nghiệm làm việc</h2>
          <div class="experience-group">
            <div v-for="(ex, index) in info_page.user_info.experience" :key="index" >
              <div class="experience">           
                <i class="fa fa-circle"></i>
                <div class="info-experience">
                  <div class="experience-major">
                    <strong class="company-name">{{ex.company}}</strong>
                    <span>{{ex.major}}</span>
                  </div>
                  <div class="time-line">
                    <span>{{ex.start_date}} - </span>
                    <span>{{ex.end_date}}</span>
                  </div>
                </div>              
              </div>              
            </div>
          </div>
        </div>
        <div v-if="info_page.status_page != 'preview'" id="rating-and-review" class="">
          <h2 class="title">Nhận xét và đánh giá</h2>          
          <rating-and-review ></rating-and-review>
        </div>        
      </div>
    </div>
  </div>
</template>
<script>
  import RatingAndReview from "../Rating/RatingAndReview.vue";
  export default {
    components: {
      RatingAndReview
    },

    props: ['info_page'],
    beforeCreate: function(){
      // console.log(info_page)
      
    },
    data: function(){
      // console.log('');
      var image_default = "../../../assets/images/counselor/candidate.png";
      var image_data = this.info_page.user_info.avatar == '' ? image_default : this.info_page.user_info.avatar;
      // var first_service = this.info_page.user_info
      // console.log(this.info_page.user_info.service_detail)
      return{
        // counselor_info: counselor_info,
        service_show: 'insider',
        image_data: image_data
      }
    },
    methods:{
      show_content: function(service_num){
        this.service_show = service_num
      }
    },

    computed:{
      image_avatar(){
        var image_default = "../../../assets/images/counselor/candidate.png";
        var image_data = this.info_page.user_info.avatar == '' ? image_default : this.info_page.user_info.avatar;
        return image_data
      },      
      introduce(){
        return this.info_page.user_info.introduce.replace(/\n/g, "<br />")
      },

    },
    mounted: function(){
    },
    created: function(){    
      // console.log(this.info_page.user_info.avatar);    
      // this.name = this.info_page.user_info.name;
      // console.log(this.info_page.user_info)

    }

    // watch: {
    //   counselor_detail(){
    //     counselor_info = this.counselor_detail;
    //   }
    // }
    // mounted: function(){
      // console.log(this.info_page.user_info.avatar)
      // this.info_page.user_info.avatar      
      // this.image_data = this.info_page.user_info.avatar
      // console.log(this.info_page.user_info.avatar_file)
    // }
  };  
</script>
<style lang="scss" scoped>
  @import "./info_counselor"
</style>


// WEBPACK FOOTER //
// src/views/components/Counselor/InfoCounselor.vue